//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import portList from "@/pcpage/hr/recruitment/portal/portList";
import * as auth from "@/utils/auth";
export default {
  // components:{
  //   portList
  // },
  name: "portal",
  data() {
    return {
      toPath: "",
      showLogin: false, //是否登录
      showPortalflag: false,
      isMobile: false,
      openMenuMobile: false,
      bottomInfo: [
        {
          title: "SUPPORT",
          expand: false,
          group: ["FAQ"],
        },
      ],
    };
  },

  watch: {
    $route: {
      handler(to) {
        let token = auth.getToken();
        let userId = auth.getTokenByKey("userId");
        let cookportalflag = auth.getTokenByKey("portalflag");
        let path = to.path;
        let portalflag = this.$route.query.portalflag;
        this.goTop();
        if (portalflag == "portal") {
          auth.setTokenByKey("portalflag", "portal");
          this.showPortalflag = true;
        } else if (cookportalflag == "portal") {
          this.showPortalflag = true;
        }
        if (this.isNotNullOrEmpty(token) || portalflag == "portal") {
          this.showLogin = true;
        }

        if (!this.showLogin) {
          if (
            "/portal/applicationList" == path ||
            "/portal/information" == path
          ) {
            this.$router.push({
              path: "/portal/login",
              query: {},
            });
          }
        }
        //设置未登录时跳转页面
        this.toPath = path;
      },
      immediate: true,
    },
  },
  methods: {
    goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    loginOut() {
      //退出登录
      this.showLogin = false;
      auth.removeToken();
      this.$router.push({
        path: "/portal/successOperate",
        query: {
          showtype: "loginout",
        },
      });
      /**this.$router.push({
                path: "/portal/portList",
                query: {},
            });**/
    },
    MenuMobile() {
      this.openMenuMobile = !this.openMenuMobile;
      console.log(this.openMenuMobile);
    },
  },
  mounted() {
    let portalflag = auth.getTokenByKey("portalflag");
    this.isMobile = this.$isMobile();
    if (portalflag == "portal") {
      this.showPortalflag = true;
    }
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/portal.vue